module.exports = __webpack_public_path__ + "static/media/icon_mensagem_enviada.10fc8fcb.svg";